<template>
    <div id="app">
        <div id="Return_Bar" style="position: relative;">
            <i class="el-icon-arrow-left"></i>
                <div @click="isreturn" class="isreturn">返回</div>
                <a style="position: absolute; top: 9px; right: 20px; z-index: 9;"  target="_blank" :href="imUrl + '/TJ_TJK_IMAction.html?token=' + imToken + '&tjkId=' + tjkInfo.id + '&userName=' + tjkInfo.realName + '&tjkNumber=' + tjkInfo.tjkNum + '&platform=assitant'">
                    <img src="@/assets/images/zx.png" style="height: 30px;" alt="">
                </a>
            </div>
        <div id="text">
                <iframe
                    id="iframeQiannui"
                    ref="iframeQiannui"
                    frameborder="no"
                    scrolling="yes"
                    allowfullscreen="true"
                    width="100%"
                    height="100%"
                    :src="QiannuiiframeURL"
                >
                    您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
                </iframe>
        </div>
                    <el-dialog
                title="提示"
                :visible.sync="currency"
                width="360px"
                >
                <div class="currency_img"><img src="../../../assets/images/voiceScene/currency_img.png" alt=""></div>
                <div class="currency_text">
                  <!-- <div v-if="this.type=='primary'">你已完成“<span class="left_span">初级场景练习</span>”的学习<br>接下来，请进行“<span  class="left_span">中级场景练习</span>”</div>
                  <div v-if="this.type=='middle'">你已完成“<span class="left_span">中级场景练习</span>”的学习<br>接下来，请进行“<span  class="left_span">实操考试</span>”</div>
                   <div v-if="this.type=='jingmaiexam'" class="specialfont">恭喜你!</div>
                <div v-if="this.type=='jingmaiexam'" class="pecialfont-text">你已通过“<span class="left_span">实操考试</span>”</div>
                <div v-if="this.type=='jingmaiexam'">接下来请进行下一个课程的学习</div> -->
                <div v-if="tjkAnswer" class="specialfont">恭喜你!</div>
                <div v-if="tjkAnswer" class="pecialfont-text">你已通过“<span class="left_span">打字测试</span>”</div>
                <div v-if="tjkAnswer" class="specialfont-small">测试结果：<span class="left_span">{{speedfraction}}字/分钟</span></div>
                <!-- <div v-if="tjkAnswer && Jump!=3">接下来请进行下一个课程的学习</div>
                <div v-if="tjkAnswer && Jump==3">接下来请进行<span class="left_span">"系统实操"</span>的学习</div> -->
                <div v-if="knowledgestate==1">你已完成“<span class="left_span">{{knowledgename}}</span>”的学习<br>接下来，请进行“<span  class="left_span">{{nextknowledgename}}</span>”的学习</div>
                <div v-if="knowledgestate==2 && Coursestate=='Exam' && tabstate==null">你已完成“<span class="left_span">{{knowledgename}}</span>”的{{nowCoursestatetext}}<br>接下来，请进行一个测试</div>
                <div v-if="knowledgestate==2 && Coursestate=='Practice' && tabstate==null">你已完成“<span class="left_span">{{knowledgename}}</span>”的{{nowCoursestatetext}}<br>接下来，请进行下一个练习</div>
                <div v-if="knowledgestate==2 && Coursestate=='Study' && tabstate==null">你已完成“<span class="left_span">{{knowledgename}}</span>”的{{nowCoursestatetext}}<br>接下来，请进行下一个课程的学习</div>
                <div v-if="knowledgestate==2 &&  tabstate==2">你已完成“<span class="left_span">{{categoryName}}</span>”的学习<br>接下来，请进行下一个阶段的学习</div>
                <div v-if="knowledgestate==2 &&  tabstate==1">你已完成{{categoryName}}全部课程的学习<br>现在可以去APP领取任务了</div>

                </div>
                <span slot="footer" class="dialog-footer">
                    <div class="currency_button">
                    <!-- <div class="determine" @click="shicaoreturn" v-if="this.type=='primary'|| this.type=='middle'">
                        去学习
                    </div> -->
                    <!-- <div class="determine" @click="goindex" v-if="this.type=='jingmaiexam'">
                        我知道了
                    </div> -->
                    <div class="determine" @click="determine" v-if="knowledgestate==1 && Operation==false">
                        去学习
                    </div>
                    <div class="determine" @click="determine" v-if="knowledgestate==1 && Operation">
                        去练习
                    </div>
                    <div class="determine" @click="determine" v-if="knowledgestate==2 && Coursestate=='Exam'">
                        去测试
                    </div>
                    <div class="determine" @click="determine" v-if="knowledgestate==2 && Coursestate=='Study'">
                        继续学习
                    </div>
                    <div class="determine" @click="determine" v-if="knowledgestate==2 && Coursestate=='Practice'">
                        去练习
                    </div>
                    <div class="otherdetermine" @click="determine" v-if="knowledgestate==2 && tabstate==2 && dazhiJump==false">
                        去报名并参加{{nextcategoryName}}
                    </div>
                    <div class="otherdetermine" @click="determine" v-if="knowledgestate==2 && tabstate==2 && dazhiJump">
                        去学习
                    </div>
                    <div class="determine" @click="goindex" v-if="knowledgestate==2 && tabstate==1">
                        我知道了
                    </div>
                    </div>
                
            
            </span>
            </el-dialog>
    </div>
</template>

<script>
export default {
    name:'OnInline',
    data() {
        return{
            tjkInfo: {},
            collegeType:this.$route.query.collegeType,
            page:this.$route.query.page,//判断是在线那个页面跳过来的
            type:this.$route.query.type,
            id:this.$route.query.id,
            assitantType:this.$route.query.assitantType,
            courseId:this.$route.query.courseId,
            knowledgeSeq:this.$route.query.knowledgeSeq,
            // courseName:this.$route.query.courseName,//实操页面每一个实操课程名字
            QiannuiiframeURL:'',//跳转千牛页面的地址
            nextobject:{},//当前知识点数据（相邻知识点数据）
            knowledgename:'',//当前知识点名字
            nextknowledgename:'',//下一个知识点名字
            nowCoursestate:'',//当前的课程状态
            nowCoursestatetext:'',//当前的课程状态的弹窗文字
            Coursestate:'',//接下跳转的课程状态
            nowCoursestate:'',//当前的课程状态
            nowCoursestatetext:'',//当前的课程状态的弹窗文字
            categoryName:'',//当前tab名字
            tabstate:null,//根据tab位置判断最后一个知识点的弹窗文字状态
            nextcategoryName:'',//下一个tab名字
            currency:false,//知识点通用弹窗控制
            knowledgestate:null,
            tjkAnswer:false,//打字认证页面跳回
            speedfraction:'',//打字速度分数
            Jump:null,//打字弹窗跳转（按钮文字）
            theoryBadge:this.$route.query.theoryBadge,//理论实操完成情况
            majorId:null,
            knowledgeId:this.$route.query.knowledgeId,//知识点id
            CourseLevel:this.$route.query.CourseLevel,
            dazhiJump:false,//打字认证跳系统实操
            Operation:false,//千牛实操，京麦实操按钮文字
            sceneId:this.$route.query.sceneId,
            imUrl: API_ROOT.imUrl,
            imToken: API_ROOT.imToken
        }

    },
    created(){
        if(localStorage.getItem('majorId')){
          this.majorId=localStorage.getItem('majorId')
        }
        console.log(this.$route.query,'跳转')
        this.getCourseDetail()
        this.iframeURLsrc()
        this.getCustomerUser()
    },
    methods:{

       goindex(){
      this.$router.push({path:'/train/index'})
    },
    getCustomerUser() {
        this.$http.get('/customer/action/currentUser/customerUser').then(response=>{
            var result = response.data;
            if(result.success) {
                this.tjkInfo = result.data;
            }else{
                this.$alert(result.msg);
            }
        },response => {
            this.$alert('AJAX访问接口异常！');
        })
    },
     //查看当前知识点（相邻知识点）
      getCourseDetail() {
       this.$http.post(API_ROOT.college + '/course/getGuideDialog', {'courseId': this.courseId,'knowledgeId':this.knowledgeId}).then(res=> {
        var result = res.data;
        console.log(result,'知识点')
        if(result.success) {

        // this.guidePopMsg=result.data.current.knowledge.guidePopMsg
        this.knowledge=result.data.current
        this.nextobject=result.data
        if(this.nextobject.next){this.knowledgeId=this.nextobject.next.knowledgeId}
            if(this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse){
              this.knowledgestate=1//知识点跳知识点
                this.knowledgeId=this.nextobject.next.knowledgeId
                this.knowledgename=this.nextobject.current.title
                this.nextknowledgename=this.nextobject.next.title
                if(this.nextobject.next.assitantType=='jingmaiexam' || this.nextobject.next.assitantType=='qianniuexam' || this.nextobject.next.assitantType=='workorderjushuitanexam'){
                 this.Operation=true
                }
            }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse){

              this.knowledgestate=2//知识点跳课程
               this.knowledgename=this.nextobject.currentCourse.courseName
                this.nextknowledgename=this.nextobject.nextCourse.courseName


                if(this.nextobject.currentCourse.courseType=='Exam'){
                 this.nowCoursestate='Exam'
                  this.nowCoursestatetext='测试'
                }else if(this.nextobject.currentCourse.courseType=='Integrate' && this.nextobject.currentCourse.assitantType){
                  if(this.nextobject.currentCourse.assitantType=='CallOutAbilityCheck'){
                    this.nowCoursestate='Exam'
                    this.nowCoursestatetext='测试'
                  }else{
                    this.nowCoursestate='Practice'
                    this.nowCoursestatetext='练习'
                  }
                }else if(this.nextobject.currentCourse.courseType=='Integrate' && !this.nextobject.currentCourse.assitantType){
                  this.nowCoursestate='Study'
                  this.nowCoursestatetext='学习'
                }

                if(this.nextobject.nextCourse.courseType=='Exam' || this.nextobject.nextCourse.assitantType=='AssitantSpecialRobotExam'){
                  this.Coursestate='Exam'
                }else if(this.nextobject.nextCourse.courseType=='Integrate' && this.nextobject.nextCourse.assitantType){

                  this.Coursestate='Practice'
                }else if(this.nextobject.nextCourse.courseType=='Integrate' && !this.nextobject.nextCourse.assitantType){
                  this.Coursestate='Study'
                }
            }
            else if(this.nextobject.nextCategory){
               this.knowledgestate=2
                   this.categoryName=this.nextobject.currentCategory.categoryName
                   var  ismajorId=localStorage.getItem('majorId')
                 this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk",{majorId:ismajorId})
                   .then(
                    (res) => {
                      var result = res.data;

                      if (result.success) {
                        let relist=result.data
                       if(this.nextobject.nextCategory){
                         if(this.nextobject.nextCategory==null){
                           this.tabstate=1
                         }else{
                         this.tabstate=2
                         this.nextobject.nextCategory.assitantType
                          relist.forEach((item,index) => {
                              if (item.assitantType == this.nextobject.nextCategory.assitantType) {
                                  if (this.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                                      this.nextcategoryName = this.nextobject.theoryBadge == false ? '理论培训':'实操培训';
                                  } else if (this.nextobject.assitantType == 'VoiceUpgradeSkill') {
                                      this.nextcategoryName = '语音技能提升'
                                  }
                                  else if (this.nextobject.nextCategory.assitantType == 'SysOperate') {
                                      this.dazhiJump = true
                                  } else {
                                      this.nextcategoryName == item.categoryName
                                  }
                              }
                          })
                       }
                      }

                      } else {
                        this.$alert(result.msg);
                      }
                    }, (res) => {
                        this.$alert(
                          "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                        );
                      })

            } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
                this.knowledgestate = 2
                this.categoryName = this.nextobject.currentCategory.categoryName
                this.tabstate = 1
            }

        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      })

    },
     // 返回按钮
    isreturn() {
       const prevRoutePath = sessionStorage.getItem('prevRoutePath')
       if (prevRoutePath === '/train/Secondarylist') {
         window.history.back()
       } else if(this.page=='dazi'){
         this.$router.push({path:'/train/index'})
       }else{
           this.$router.push({path:'/train/Secondarylist',query:{courseId:this.courseId, collegeType:this.$route.query.collegeType}})
       }
    },
    iframeURLsrc(){
        var showanswerParam = this.$route.query.showanswer  && this.$route.query.showanswer === 'false' ? '&showanswer=false' : '';

        if (this.type == 'qianniu') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniu?type=-1&id=-100&OnInline=true'
        } else if (this.type == 'workorderjushuitan') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/jushuitanerpStudy?OnInline=true' + (this.courseId ? '&courseId=' + encodeURIComponent(this.courseId) : '') + (this.knowledgeId ? '&knowledgeId=' + encodeURIComponent(this.knowledgeId) : '')
        } else if (this.type == 'qianniuexam') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniuexam?type=-1&id=-99&OnInline=true'
        } else if (this.type == 'workorderjushuitanexam') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/jushuitanerpexam?OnInline=true' + (this.courseId ? '&courseId=' + encodeURIComponent(this.courseId) : '')
        } else if (this.type == 'jingmai') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/jmStudy?type=-1&id=-98&OnInline=true'
        } else if (this.type == 'jingmaiexam') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/jmExam?type=-1&id=-97&OnInline=true'
        } else if (this.type == 'wpsexcel') {
            this.QiannuiiframeURL = '/tjkStudy/newexcel?OnInline=true'
        } else if (this.type == 'wpsexcelexam') {
            this.QiannuiiframeURL = '/tjkStudy/excelstudy?OnInline=true'
        } else if (this.type == 'sougouinput') {
            this.QiannuiiframeURL = '/tjkStudy/typewriting?OnInline=true'
        } else if (this.type == 'sougouinputexam') {
            this.QiannuiiframeURL = '/tjkStudy/typewritingstudy?OnInline=true'
        } else if (this.type == 'feige') {
            this.QiannuiiframeURL = '/tjkStudy/feiGeTrain?OnInline=true'
        } else if (this.type == 'feigeexam') {
            this.QiannuiiframeURL = '/tjkStudy/feiGeTrainExam?OnInline=true'
        }else if (this.type == 'primary') {
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=2' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        } else if (this.type == 'middle') {
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=2&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=4' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        } else if (this.type == 'high') {
            var param = this.collegeType == 'allSaleExam' ? 'collegeType=high&' : '';//记录类型，传到对练系统，记录结果存到college里
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?'+param+'type=0&abilityType=2&id=' + this.id + showanswerParam  + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=5' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        }else if (this.type == 'aftersaleprimary') {
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam  + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=2' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        } else if (this.type == 'aftersalemiddle') {
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam  + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=4' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        } else if (this.type == 'aftersalehigh') {
            var param = this.collegeType == 'allSaleExam' ? 'collegeType=aftersalehigh&' : '';
            this.QiannuiiframeURL = '/cloudtraining/customer/scene/?'+param+'type=0&abilityType=1&id=' + this.id + showanswerParam  + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=5' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '')
        }else if (this.page == 'dazi') {
            this.QiannuiiframeURL = '/tjkStudy/examTyping/10063?OnInline=true'
        }else if (this.type == 'qianniuexam_11618') {
            //双11 618
            this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniuexam_11618?type=-1&id=-99&OnInline=true'
        }else if (this.type == 'jingmaiexam_11618') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/jmExam_11618?type=-1&id=-97&OnInline=true'
        }else if (this.type == 'feigeexam_11618') {
            this.QiannuiiframeURL = '/tjkStudy/feiGeTrainExam_11618?OnInline=true'
        }else if (this.type == 'pdd') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/pddStudy?OnInline=true'
        }else if (this.type == 'pddexam') {
            this.QiannuiiframeURL = '/tjkStudy/simulate/pddExam?OnInline=true'
        }
    },
      //点击前往下一个课程或知识点
    determine(){
     if(this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory ){
         var assitantType = this.nextobject.next.assitantType;
      if(assitantType != null &&
                (assitantType.indexOf('qianniu')>-1
              || assitantType.indexOf('jingmai')>-1
              || assitantType.indexOf('feige')>-1
              || assitantType.indexOf('wpsexcel')>-1
              || assitantType.indexOf('sougouinput')>-1
              || assitantType.indexOf('pdd')>-1
              || assitantType.indexOf('workorderjushuitan')>-1
                )){
           window.location.href="/tjkStudy/train/OnInline?type="+assitantType+'&courseId='+this.nextobject.next.courseId+'&knowledgeSeq='+this.nextobject.next.knowledgeSeq+'&knowledgeId='+this.nextobject.next.knowledgeId
      }else{
        this.nextcourseId=this.nextobject.next.courseId
         window.location.href ="/tjkStudy/vedioDetail?courseId=" +this.nextcourseId+'&knowledgeSeq='+this.nextobject.next.knowledgeSeq+'&CourseLevel='+this.CourseLevel+'&sceneId='+this.$route.query.sceneId+'&assitantTjkId='+this.$route.query.tjkId+'&tjkId='+this.$route.query.tjkId+'&trainId='+this.$route.query.trainId+'&knowledgeId='+this.knowledgeId
      }


      }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse &&  this.nextobject.next){
        this.nextcourseId=this.nextobject.nextCourse.courseId
        this.toStudy()
      }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse){
         this.nextcourseId=this.nextobject.nextCourse.courseId

         this.gotoStudy()
      }else if(this.nextobject.nextCategory){
               var  ismajorId=localStorage.getItem('majorId')
             this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk",{majorId:ismajorId})
               .then(
                (res) => {
                  var result = res.data;
                  if (result.success) {
                    let relist=result.data

                   if(this.nextobject.nextCategory){
                     if(this.nextobject.nextCategory==null){
                       this.tabstate=1
                     }else{
                     this.tabstate=2
                      relist.forEach((item,index) => {
                        if(item.assitantType==this.nextobject.nextCategory.assitantType){
                          if(this.nextobject.nextCategory.assitantType=='OnlineUpgradeSkill'){
                            localStorage.setItem('tabIndex',index)
                            localStorage.setItem('majorId',item.majorId)
                          }else if(this.nextobject.assitantType=='VoiceUpgradeSkill'){
                            localStorage.setItem('tabIndex',index)
                            localStorage.setItem('majorId',item.majorId)
                          }else{
                             localStorage.setItem('tabIndex',index)
                             localStorage.setItem('majorId',item.majorId)
                             localStorage.setItem('categoryId',item.categoryId)
                          }
                        }
                      })
                   }
                  }
                      this.$router.push({path: '/train/index'})

                  } else {
                    this.$alert(result.msg);
                  }
                }, (res) => {
                    this.$alert(
                      "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                    );
                  })


      }

    },
       test(i){
         console.log(i,'穿过来了')
         if(i){
           this.speedfraction=i
           this.tjkAnswer=true
         }
           console.log(i,'分数')
           this.currency=true

    },
     gotoStudy() {
         this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.nextcourseId})
        .then(
          (res) => {

            var result = res.data;

              if (result.success) {
                  if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                      this.$router.push({path: '/train/Secondarylist', query: {courseId: this.nextcourseId}})
                  } else if (this.CourseLevel == 3) {
                      this.$router.back()
                  }
                  else {
                      this.tabIndex = localStorage.getItem('tabIndex')
                      this.$router.push({
                          path: '/train/index',
                          query: {
                              tabIndex: this.tabIndex,
                              condition: true//判断是否是基础知识点跳课程
                          }
                      })
                  }


              } else {
                  this.$alert(result.msg);
              }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
      toStudy() {
         this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.nextcourseId})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
             if(result.data.knowledgeRecordFullList.length!=1 && result.data.knowledgeRecordFullList.length!=0) {
                 this.$router.push({path:'/train/Secondarylist',query:{courseId:this.nextcourseId

                 }})
             }else if(this.CourseLevel==3){
                this.$router.back();
              }else if(result.data.knowledgeRecordFullList.length==1){
                  window.location.href='/tjkStudy/vedioDetail?courseId='+this.nextcourseId+'&knowledgeSeq='+this.nextobject.next.knowledgeSeq+'&CourseLevel='+this.CourseLevel+'&sceneId='+this.$route.query.sceneId+'&assitantTjkId='+this.$route.query.tjkId+'&tjkId='+this.$route.query.tjkId+'&trainId='+this.$route.query.trainId+'&knowledgeId='+this.knowledgeId
             }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
},
     mounted() {
         let self = this;
         window["goBack"] = (i) => {
             self.test(i);
         };
     },

}
</script>
<style lang="less" scoped>
#app {
  height: 100%;
  box-sizing: border-box;
  background: #f6f5f8;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
  background: #fff;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
}
.isreturn {
  color: #262626;
  cursor: pointer;
  margin-top: 2px;
}
.timestyle{margin: 0 20px;height: 28px;line-height: 28px;}
/deep/.el-dialog{border-radius: 10px;}
/deep/.el-dialog__header{border-bottom: 1px solid #E9E9E9;}
/deep/.el-dialog__title {font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;}
.currency_img{width: 85px;height: 64px;margin: 0 auto;margin-bottom: 12px;}
.currency_img>img{width:100%;height:100%;}
.currency_text{text-align: center;font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #262626;line-height: 20px;}
.currency_text>span{color: #497AF2}
.cancel{width: 80px;height: 28px;background: #E1E1E1;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #717171;text-align: center;line-height: 28px;margin-right: 10px;}
.determine{width: 80px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 28px;cursor: pointer;}
.currency_button{display: flex;justify-content: center;}
.left_span{color: #497AF2;}
.otherdetermine{padding:0px 15px 0px 15px;height: 33px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 33px;cursor: pointer;}
.specialfont{font-size: 18px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;line-height: 18px;margin-bottom: 11px;margin-top: 12px;}
.specialfont-small{margin-top: 3px;margin-bottom: 12px;font-size: 11px;}
.pecialfont-text{font-size: 14px;}
</style>



// WEBPACK FOOTER //
// ./src/page/train/newservice/OnInline.vue